import { CommaStringsMaskDirective } from './comma-strings-mask/comma-strings-mask.directive';
import { PhoneMaskDirective } from './phone-mask/phone-mask.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImagePreloadDirectiveDirective } from './image-pre-load/image-preload-directive.directive';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AgAutoFocusDirective } from './ag-fields/ag-autofocus.directive';
import { AutoWidthDirective } from './inputs/auto-width.directive';
import { VisualizeSpacesDirective } from './inputs/visualize-spaces.directive';
import { AutocompleteKeySelectDirective } from './autocomplete-key-select.directive';
import { InputClearOnBlurDirective } from './input-clear-onblur.directive';
import { AgInteractDirective } from './inputs/ag-interact.directive';
import { SelectAllOptionsDirective } from '../../directives/select-all-options.directive';
import { MatTabGroupBeforeTabChangeDirective } from './mat-tab-group/mat-tab-group-before-tab-change.directive.ts';
import { NumbersOnlyDirective } from './numbers-only/ag-numbers-only.directive';

@NgModule({
  imports: [CommonModule, NgbModule],
  declarations: [
    AgAutoFocusDirective,
    AutocompleteKeySelectDirective,
    AutoWidthDirective,
    CommaStringsMaskDirective,
    InputClearOnBlurDirective,
    ImagePreloadDirectiveDirective,
    PhoneMaskDirective,
    VisualizeSpacesDirective,
    AgInteractDirective,
    SelectAllOptionsDirective,
    MatTabGroupBeforeTabChangeDirective,
    NumbersOnlyDirective,
  ],
  exports: [
    AgAutoFocusDirective,
    AutocompleteKeySelectDirective,
    AutoWidthDirective,
    CommaStringsMaskDirective,
    ImagePreloadDirectiveDirective,
    InputClearOnBlurDirective,
    PhoneMaskDirective,
    VisualizeSpacesDirective,
    AgInteractDirective,
    SelectAllOptionsDirective,
    MatTabGroupBeforeTabChangeDirective,
    NumbersOnlyDirective,
  ],
})
export class DirectiveModule {}
